module.exports = __webpack_public_path__ + "static/img/logo-big.d90e086.png";